// extracted by mini-css-extract-plugin
export default {"searchContainer":"TaskSearch_searchContainer__JSaRr"};